export default "__VITE_ASSET__DoVpoVTq__"